import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function EmployeeNavbarVertical({ isOpen, onToggle }) {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const [activeTab, setActiveTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("tab") || "dashboard";
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setActiveTab(params.get("tab") || "dashboard");
  }, [location.search]);

  useEffect(() => {
    const handler = (e) => setActiveTab(e.detail);
    window.addEventListener("employeeSprintTabChange", handler);
    return () => window.removeEventListener("employeeSprintTabChange", handler);
  }, []);

  const openSprintTab = (tab) => {
  // Always navigate through react-router — never a raw window.history call
  // or a custom event — so react-router's own location/searchParams stay
  // the single source of truth. Navigating to the same route with a new
  // ?tab= value updates in place without remounting, so this behaves the
  // same whether we're already on the dashboard or coming from elsewhere,
  // and always takes effect on the first click.
  navigate(`/employee-dashboard?tab=${tab}`);
};
const isPath = (p) => pathname === p;
  const startsWith = (p) => pathname.startsWith(p);

  // authority-based access — only true if this person is an active row in
  // Authority for their own email (set by JWTService at login)
  const allowedPages = JSON.parse(localStorage.getItem("allowedPages") || "[]");
  const isAuthority = allowedPages.includes("/onboarddeboard/leave/leave-application/approval");
  const [leaveOpen, setLeaveOpen] = React.useState(
    startsWith("/onboarddeboard/leave/leave-application")
  );

  return (
    <nav
      className={`nav flex-column p-2 bg_blue vertical-navbar employee-vertical-nav ${isOpen ? "open" : "closed"}`}
    >

      <style>{`
        .employee-vertical-nav {
          position: fixed;
          top: 56px;
          left: 0;
          width: 240px;
          height: calc(100vh - 56px);
          background-color: #fff !important;
          border-right: 1px solid #e5e7eb;
          overflow-y: auto;
          z-index: 1050;
          display: flex;
          flex-direction: column;
          box-shadow: 2px 0 8px rgba(0,0,0,0.04);
          transition: width 0.25s ease;
        }
        .employee-vertical-nav.closed { width: 60px; }

        .emp-nav-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 14px;
          font-size: 14px;
          font-weight: 500;
          color: #374151;
          cursor: pointer;
          border-radius: 6px;
          margin: 2px 6px;
          transition: background 0.15s;
          text-decoration: none;
        }
        .emp-nav-item:hover { background: rgba(37,99,235,0.12); color: #1d4ed8; }
        .emp-nav-item.active { background: #909397; color: #fff; font-weight: 600; }
        .emp-nav-item:hover { background: #2E5CB8; color: #fff; }
        .emp-nav-item:hover i { color: #fff !important; }
        .emp-nav-item.active { background: #2E5CB8; color: #fff; font-weight: 600; }
        .emp-nav-item.active i { color: #fff !important; }
        .emp-nav-item i { color: #6b7280; font-size: 16px; flex-shrink: 0; }

        .emp-nav-section {
          padding: 10px 14px;
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          font-weight: 600;
          color: #374151;
          cursor: pointer;
          border-radius: 6px;
          margin: 2px 6px;
          transition: background 0.15s;
        }
       .emp-nav-section:hover { background: #2E5CB8; color: #fff; }
.emp-nav-section:hover i.section-icon,
.emp-nav-section:hover i.chevron { color: #fff; }
.emp-nav-section.active { background: #2E5CB8; color: #fff; font-weight: 700; }
.emp-nav-section.active i.section-icon,
.emp-nav-section.active i.chevron { color: #fff; }
        .emp-nav-section i.section-icon { color: #6b7280; font-size: 16px; }
        .emp-nav-section i.chevron { color: #9ca3af; font-size: 12px; margin-left: auto; }

        .emp-nav-sub {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 7px 14px 7px 38px;
          font-size: 13px;
          font-weight: 400;
          color: #6b7280;
          cursor: pointer;
          border-radius: 6px;
          margin: 1px 6px;
          transition: background 0.15s;
          text-decoration: none;
        }
        .emp-nav-sub:hover { background: rgba(37,99,235,0.1); color: #2563eb; }
       .emp-nav-sub.active { background: rgba(37,99,235,0.15); color: #2563eb; font-weight: 600; }
        .emp-nav-sub:hover { background: #eff6ff; color: #2E5CB8; }
.emp-nav-sub.active { background: #eff6ff; color: #2E5CB8; font-weight: 600; }
        .emp-nav-dot {
          width: 6px; height: 6px; border-radius: 50%;
          background: #d1d5db; flex-shrink: 0;
        }
       .emp-nav-sub.active .emp-nav-dot,
        .emp-nav-sub:hover .emp-nav-dot { background: #2563eb; }
        .emp-nav-sub.active .emp-nav-dot,
.emp-nav-sub:hover .emp-nav-dot { background: #2E5CB8; }

        .emp-nav-leave-header {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 14px;
          font-size: 14px;
          font-weight: 500;
          color: #374151;
          cursor: pointer;
          border-radius: 6px;
          margin: 2px 6px;
        }
        .emp-nav-leave-header:hover { background: rgba(37,99,235,0.12); }

      `}</style>

      {/* ── Nav body ── */}
<div style={{ flex: 1, padding: "8px 0", overflowY: "auto" }}>

        {/* ── Dashboard ── */}
        {isOpen ? (
          <div
            className={`emp-nav-item${pathname === "/employee-dashboard" && activeTab === "dashboard" ? " active" : ""}`}
            onClick={() => openSprintTab("dashboard")}
          >
            <i className="bi bi-grid-1x2-fill"></i>
            <span>Dashboard</span>
          </div>
        ) : (
          <OverlayTrigger placement="right" overlay={<Tooltip>Dashboard</Tooltip>}>
            <div className="emp-nav-item" onClick={() => openSprintTab("dashboard")} style={{ justifyContent: "center", padding: "10px 0" }}>
              <i className="bi bi-grid-1x2-fill"></i>
            </div>
          </OverlayTrigger>
        )}

        {/* ── Sprint section ── */}
        <SprintSection isOpen={isOpen} openSprintTab={openSprintTab} startsWith={startsWith} activeTab={activeTab} />

        

        {/* ── Ticketing standalone ── */}
        {isOpen ? (
          <div
            className={`emp-nav-item${startsWith("/employee-ticketing") ? " active" : ""}`}
            onClick={() => navigate("/employee-ticketing")}
          >
            <i className="bi bi-ticket-perforated-fill"></i>
            <span>Ticketing</span>
          </div>
        ) : (
          <OverlayTrigger placement="right" overlay={<Tooltip>Ticketing</Tooltip>}>
            <div className={`emp-nav-item${startsWith("/employee-ticketing") ? " active" : ""}`} onClick={() => navigate("/employee-ticketing")} style={{ justifyContent: "center", padding: "10px 0" }}>
              <i className="bi bi-ticket-perforated-fill"></i>
            </div>
          </OverlayTrigger>
        )}
         {/* ── Leave — collapsible group, matches admin sidebar style/colors ── */}
        {isOpen ? (
          <>
            <div
              className={`emp-nav-leave-header${startsWith("/onboarddeboard/leave/leave-application") ? " active" : ""}`}
              onClick={() => setLeaveOpen((v) => !v)}
            >
              <i className="bi bi-calendar2-week-fill"></i>
              <span style={{ flex: 1 }}>Leave Application</span>
              <i className="bi bi-chevron-right" style={{ fontSize: 11, transform: leaveOpen ? "rotate(90deg)" : "none", transition: "transform 0.2s" }}></i>
            </div>
            {leaveOpen && (
              <>
                <div
                  className={`emp-nav-sub${isPath("/onboarddeboard/leave/leave-application/apply") ? " active" : ""}`}
                  onClick={() => navigate("/onboarddeboard/leave/leave-application/apply")}
                >
                  <span className="emp-nav-dot"></span>
                  Employee Leave Application
                </div>
                {isAuthority && (
                  <div
                    className={`emp-nav-sub${isPath("/onboarddeboard/leave/leave-application/approval") ? " active" : ""}`}
                    onClick={() => navigate("/onboarddeboard/leave/leave-application/approval")}
                  >
                    <span className="emp-nav-dot"></span>
                    Leave Approval
                  </div>
                )}
                <div
                  className={`emp-nav-sub${isPath("/onboarddeboard/leave/leave-application/compensatory-request") ? " active" : ""}`}
                  onClick={() => navigate("/onboarddeboard/leave/leave-application/compensatory-request")}
                >
                  <span className="emp-nav-dot"></span>
                  Compensatory Leave Request
                </div>
                {isAuthority && (
                  <div
                    className={`emp-nav-sub${isPath("/onboarddeboard/leave/leave-application/compensatory-approval") ? " active" : ""}`}
                    onClick={() => navigate("/onboarddeboard/leave/leave-application/compensatory-approval")}
                  >
                    <span className="emp-nav-dot"></span>
                    Compensatory Request Approval
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          <OverlayTrigger placement="right" overlay={<Tooltip>Leave Application</Tooltip>}>
            <div className={`emp-nav-item${startsWith("/onboarddeboard/leave/leave-application") ? " active" : ""}`} onClick={() => navigate("/onboarddeboard/leave/leave-application/apply")} style={{ justifyContent: "center", padding: "10px 0" }}>
              <i className="bi bi-calendar2-week-fill"></i>
            </div>
          </OverlayTrigger>
        )}
        {/* ── Reporting section ── */}
        <ReportingSection isOpen={isOpen} startsWith={startsWith} isPath={isPath} />

      </div>

      {/* ── Bottom: Logout ── */}
      <div style={{ borderTop: "1px solid #f1f5f9", padding: "8px 0" }}>
        <div
          className="emp-nav-item"
          style={{ color: "#ef4444" }}
          onClick={() => { localStorage.clear(); window.location.href = "/"; }}
        >
          <i className="bi bi-box-arrow-right" style={{ color: "#ef4444" }}></i>
          {isOpen && <span>Log Out</span>}
        </div>
      </div>
    </nav>
  );
}

/* ── Sprint section with expand/collapse ── */
function SprintSection({ isOpen, openSprintTab, startsWith, activeTab }) {
  const [open, setOpen] = React.useState(true);
  const isActive = startsWith("/employee-dashboard") && activeTab !== "dashboard";

  if (!isOpen) {
    return (
      <OverlayTrigger placement="right" overlay={<Tooltip>Sprint</Tooltip>}>
        <div className={`emp-nav-item${isActive ? " active" : ""}`} onClick={() => openSprintTab("active")} style={{ justifyContent: "center", padding: "10px 0" }}>
          <i className="bi bi-lightning-charge-fill"></i>
        </div>
      </OverlayTrigger>
    );
  }

  return (
    <>
      <div className={`emp-nav-section${isActive ? " active" : ""}`} onClick={() => setOpen(o => !o)}>
        <i className="bi bi-lightning-charge-fill section-icon"></i>
        <span style={{ flex: 1 }}>Sprint</span>
        <i className={`bi bi-chevron-right chevron`} style={{ transform: open ? "rotate(90deg)" : "none", transition: "transform 0.2s" }}></i>
      </div>
      {open && (
        <>
          <div className={`emp-nav-sub${activeTab === "active" ? " active" : ""}`} onClick={() => openSprintTab("active")}>
            <span className="emp-nav-dot"></span>
            Active Sprint
          </div>
          <div className={`emp-nav-sub${activeTab === "completed" ? " active" : ""}`} onClick={() => openSprintTab("completed")}>
            <span className="emp-nav-dot"></span>
            Completed Sprint
          </div>
        </>
      )}
    </>
  );
}

/* ── Reporting section with expand/collapse ── */
function ReportingSection({ isOpen, startsWith, isPath }) {
  const [open, setOpen] = React.useState(true);
  const isActive = startsWith("/employeereporting");

  if (!isOpen) {
    return (
      <OverlayTrigger placement="right" overlay={<Tooltip>Reporting</Tooltip>}>
        <div className={`emp-nav-item${isActive ? " active" : ""}`} onClick={() => { }} style={{ justifyContent: "center", padding: "10px 0" }}>
          <i className="bi bi-bar-chart-fill"></i>
        </div>
      </OverlayTrigger>
    );
  }

  return (
    <>
      <div className={`emp-nav-section${isActive ? " active" : ""}`} onClick={() => setOpen(o => !o)}>
        <i className="bi bi-bar-chart-fill section-icon"></i>
        <span style={{ flex: 1 }}>Reports</span>
        <i className="bi bi-chevron-right chevron" style={{ transform: open ? "rotate(90deg)" : "none", transition: "transform 0.2s" }}></i>
      </div>
      {open && (
        <>
          <a className={`emp-nav-sub${isPath("/employeereporting/dailyreporting") ? " active" : ""}`} href="/employeereporting/dailyreporting" onClick={e => { e.preventDefault(); window.location.href = "/employeereporting/dailyreporting"; }}>
            <span className="emp-nav-dot"></span>
            Daily Report
          </a>
         <a className={`emp-nav-sub${isPath("/employeereporting/employeedailyreport") ? " active" : ""}`} href="/employeereporting/employeedailyreport" onClick={e => { e.preventDefault(); window.location.href = "/employeereporting/employeedailyreport"; }}>
            <span className="emp-nav-dot"></span>
            My Reports
          </a>
        </>
      )}
    </>
  );
}

export default EmployeeNavbarVertical;